import { createFileRoute, useRouter } from "@tanstack/react-router";
import { z } from "zod";
import { ResetLinkExpiry } from "@/components/features/ResetLinkExpiry/ResetLinkExpiry";

const resetLinkExpirySearchSchema = z.object({
  state: z.enum(["expired", "rate-limited"]).default("expired"),
  until: z.string().optional(),
});

export const Route = createFileRoute("/_unauthenticated/reset-link-expiry/")({
  validateSearch: resetLinkExpirySearchSchema.parse,
  component: ResetLinkExpiryRouteComponent,
});

function ResetLinkExpiryRouteComponent() {
  const { navigate } = useRouter();
  const { state, until } = Route.useSearch();

  return (
    <ResetLinkExpiry
      state={state}
      until={until}
      onRequestNewLink={() => navigate({ to: "/forgot-password" })}
      onReturnToLogin={() => navigate({ to: "/login" })}
    />
  );
}
